<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-12">
                <br />
                <br />
                <h1 class="display-3 text-white">
                  Input Pendaftaran - Pelayanan Pajak BPHTB
                  <span>Kabupaten Ketapang</span>
                </h1>
                <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg pt-lg-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-sm-3 mb-2">
                <template v-if="isBusy">
                  <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                  <strong>Loading NOP...</strong>
                </template>
              </div>
            </div>
            <div class="row row-grid">
              <card class="border-0" shadow body-classes="py-5">
                <div class="row">
                  <div class="col-lg-12 my-1">
                    <div class="btn-wrapper float-left">
                      <base-button tag="a" class="mb-3 mb-sm-0" type="info" textColor="black" icon="fa fa-arrow-left"
                        @click="goback()">Kembali</base-button>
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
                <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
                  <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
                    <div class="row">
                      <div class="col-sm-12 mb-2">
                        <span class="text-sm" v-if="originalData.length > 0">{{
                          originalData.daftar.keterangan_verifikasi
                        }}</span>
                      </div>
                    </div>
                    <br>
                    <div class="row">
                      <div class="col-sm-3 mb-2">
                        <div class="form-group has-label">
                          <label> Jenis SK</label>
                          <!-- <v-select :options="optionJenisSK" v-model="form.jenis_sk" :reduce="(opt) => opt.value"
                                :getOptionLabel="(opt) => opt.val" class="form-control" placeholder="~~ Pilih Jenis SK ~~"
                                :disabled="true">
                              </v-select> -->
                          <select class="form-control" v-model="form.jenis_sk" :class="'is-valid'"
                            style="background-color: #e9ecef;opacity: 1;">
                            <option :value="val.value" :disabled="true" v-for="(val, index) in optionJenisSK"
                              :key="index">{{ val.value }} - {{ val.text }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-3 mb-2">
                        <base-input label="Tahun" disabled v-model="form.thn_pajak" />
                      </div>
                      <div class="col-md-6 mb-2">
                        <base-input label="PPAT" disabled :value="form.kode_ppat +
                          ' - ' +
                          $store.state.auth.user.ppat.nama_ppat
                          " />
                      </div>
                    </div>
                    <fieldset style="padding: 5px; margin-top: 10px">
                      <legend>Objek Pajak</legend>
                      <div class="row">
                        <div class="col-md-6 mb-2">
                          <ValidationProvider name="NOP" rules="required|min:16" v-slot="{ errors }">

                            <div class="form-group">
                              <label>
                                NOP
                                <span>*</span>
                              </label>
                              <masked-input v-model="form.objek_pajak.nop" class="form-control" :class="[
                                { 'is-valid': !errors[0] },
                                { 'is-invalid': errors[0] },
                              ]" mask="11.11.111.111.111.1111.1" @change="cekNop()" />
                              <!-- <base-input-mask label="NOP" type="number"  :error="errors[0]"
                                  :valid="!errors[0]"  name="nop" :required="true" /> -->
                              <span class="text-danger text-sm" v-show="errors[0]">{{
                                errors[0]
                              }}</span>
                            </div>
                          </ValidationProvider>
                        </div>
                        <div class="col-sm-3 mb-2">
                          <template v-if="isBusyNop">
                            <pulse-loader :loading="isBusyNop" :color="'#d7f6e8'"></pulse-loader>
                            <strong>Loading NOP...</strong>
                          </template>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-8 mb-2">
                          <ValidationProvider name="Nama Pemilik" rules="required" v-slot="{ errors }">
                            <base-input disabled label="Nama Pemilik" v-model="form.subjek_pajak.nm_wp" :required="true"
                              name="nm_wp" :error="errors[0]" :valid="!errors[0]" />
                          </ValidationProvider>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                          <ValidationProvider name="No Tlp. Pemilik" rules="required" v-slot="{ errors }">
                            <base-input label="No Tlp. Pemilik" v-model="form.objek_pajak.no_telp" :error="errors[0]"
                              :required="true" :valid="!errors[0]" />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 mb-2">
                          <ValidationProvider name="Alamat Pemilik" rules="required" v-slot="{ errors }">
                            <base-input disabled label="Alamat Pemilik" v-model="form.subjek_pajak.jalan_op"
                              :required="true" name="jalan_op" :error="errors[0]" :valid="!errors[0]" />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2">
                          <base-input label="No Sertifikat" v-model="form.objek_pajak.no_sertf" />
                        </div>
                      </div>
                      <div class="row" v-if="piutang.length > 0">
                        <div class="table-responsive-sm col-md-12 mb-2">
                          <table class="
                                    table
                                    b-table
                                    table-hover table-bordered table-sm
                                  ">
                            <thead>
                              <th class="text-center">NOP</th>
                              <th class="text-center">Tahun SPPT</th>
                              <th class="text-right">Jumlah Terhutang</th>
                            </thead>

                            <tbody>
                              <tr :key="indextr" v-for="(tr, indextr) in piutang">
                                <td class="text-center">
                                  {{ form.objek_pajak.nop }}
                                </td>

                                <td class="text-center">
                                  {{ piutang[indextr].thn_pajak_sppt }}
                                </td>

                                <td class="text-right">
                                  {{
                                    formatMoney(
                                      piutang[indextr].pbb_yg_harus_dibayar_sppt
                                    )
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="row float-right" v-if="piutang.length > 0">
                        <div class="col-md-12 col-sm-12">
                          <template v-if="loadingCetakTunggakan">
                            <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                            <strong>Loading...</strong>
                          </template>
                          <base-button v-else type="warning" @click="cetakTunggakan"><i class="fa fa-print"></i> Cetak
                            Tunggakan</base-button>
                        </div>
                      </div>
                    </fieldset>
                    <template v-if="piutang.length == 0">
                      <fieldset style="padding: 5px; margin-top: 10px">
                        <legend>Detail Wajib Pajak</legend>

                        <div class="row">
                          <div class="col-md-4 col-sm-12">
                            <div class="form-group">
                              <label>
                                Jenis Wajib Pajak
                                <span>*</span>
                              </label>
                              <select class="form-control" v-model="form.jenis_wp" :class="'is-valid'">
                                <option value="1">1 - Pribadi</option>
                                <option value="2">
                                  2 - Badan
                                </option>
                                <option value="3">
                                  3 - Fasum
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4 mb-2">
                            <ValidationProvider name="Nomor Identitas" rules="required|max:20" v-slot="{ errors }">
                              <base-input type="number" :label="labelIdenditas" v-model="form.wajib_pajak.nik"
                                :required="true" name="nik" :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-3 mb-2">
                            <template v-if="isBusyWp">
                              <pulse-loader :loading="isBusyWp" :color="'#d7f6e8'"></pulse-loader>
                              <strong>Loading Wajib Pajak...</strong>
                            </template>
                          </div>
                        </div>

                        <div class="row" v-show="!npoptkp">
                          <div class="col-sm-12 mb-2">
                            <span class="text-danger text-sm">Wajib Pajak ini sudah melakukan transaksi BPHTB
                              pada tahun ini, Sehingga tidak dikenakan
                              NPOPTKP.</span>
                          </div>
                        </div>
                        <div class="row">
                          <!-- <div class="col-sm-4 mb-2">
                                <base-input label="NPWP" v-model="form.wajib_pajak.npwp" />
                              </div> -->
                          <div class="col-md-8 mb-2">
                            <ValidationProvider name="Nama Wajib Pajak" rules="required|max:60" v-slot="{ errors }">
                              <base-input label="Nama Wajib Pajak" v-model="form.wajib_pajak.nama" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-12 col-md-4 mb-2">
                            <ValidationProvider name="No Tlp. Wajib Pajak / Pembeli" rules="required"
                              v-slot="{ errors }">
                              <base-input label="No Tlp. Wajib Pajak / Pembeli" v-model="form.wajib_pajak.handphone"
                                :required="true" :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <ValidationProvider name="Jalan" rules="required|max:30" v-slot="{ errors }">
                              <base-input label="Jalan" v-model="form.wajib_pajak.jalan" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-2 mb-2">
                            <ValidationProvider name="Blok/Kav/No." rules="required|max:10" v-slot="{ errors }">
                              <base-input label="Blok/Kav/No." v-model="form.wajib_pajak.blok_kav_no" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-2 mb-2">
                            <ValidationProvider name="RT" rules="required|max:3" v-slot="{ errors }">
                              <base-input type="number" label="RT" v-model="form.wajib_pajak.rt" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-2 mb-2">
                            <ValidationProvider name="RW" rules="required|max:3" v-slot="{ errors }">
                              <base-input type="number" label="RW" v-model="form.wajib_pajak.rw" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-3 mb-2">
                            <ValidationProvider name="Kelurahan / Desa" rules="required|max:50" v-slot="{ errors }">
                              <base-input label="Kelurahan / Desa" v-model="form.wajib_pajak.kelurahan" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-3 mb-2">
                            <ValidationProvider name="Kecamatan" rules="required|max:50" v-slot="{ errors }">
                              <base-input label="Kecamatan" v-model="form.wajib_pajak.kecamatan" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-3 mb-2">
                            <ValidationProvider name="Kabupaten/Kota" rules="required|max:50" v-slot="{ errors }">
                              <base-input label="Kabupaten/Kota" v-model="form.wajib_pajak.kota" :required="true"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                          <div class="col-sm-3 mb-2">
                            <ValidationProvider name="Kode Pos" rules="max:5" v-slot="{ errors }">
                              <base-input type="number" label="Kode Pos" v-model="form.wajib_pajak.kd_pos"
                                :error="errors[0]" :valid="!errors[0]" />
                            </ValidationProvider>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset style="padding: 5px; margin-top: 10px">
                        <legend>Perhitungan NPOP SELF</legend>
                        <div class="row">
                          <div class="col-sm-6 mb-2">
                            <ValidationProvider name="Jenis Peralihan" rules="required" v-slot="{ errors }">
                              <div class="form-group has-label">
                                <label> Jenis Peralihan
                                  <span>*</span></label>

                                <select class="form-control" v-model="form.kode_jns" :class="[
                                  { 'is-valid': !errors[0] },
                                  { 'is-invalid': errors[0] },
                                ]">
                                  <option value="">Pilih Jenis Peralihan</option>
                                  <option :value="val.kode_jns" v-for="(val, index) in optionPeralihan" :key="index">
                                    {{ val.kode_jns }} - {{ val.jenis_prh }}</option>
                                </select>
                                <span class="text-danger text-sm" v-show="errors[0]">{{
                                  errors[0]
                                }}</span>
                              </div>
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="btn-wrapper float-right">
                              <base-button tag="a" class="mb-3 mb-sm-0" type="info" textColor="black"
                                icon="fa fa-calculator" @click="calculateField()">Hitung</base-button>
                            </div>
                          </div>
                        </div>
                        <br>
                        <div class="row">
                          <div class="table-responsive-sm col-md-12">
                            <table class="
                                      table
                                      b-table
                                      table-hover table-bordered table-sm
                                    ">
                              <thead>
                                <tr class="
                                          tr-values
                                          vs-table--tr
                                          tr-table-state-null
                                        ">
                                  <th style="width: 150px">URAIAN</th>
                                  <th>&nbsp;</th>
                                  <th>LUAS (m<sup>2</sup>)</th>
                                  <th>&nbsp;</th>
                                  <th>NJOP PBB / M<sup>2</sup></th>
                                  <th>&nbsp;</th>
                                  <th>LUAS X NJOP / M<sup>2</sup></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="
                                          tr-values
                                          vs-table--tr
                                          tr-table-state-null
                                        ">
                                  <td>Tanah</td>
                                  <td style="width: 10px">11.</td>
                                  <td>
                                    <div class="form-group">
                                      <money v-bind="money" disabled class="form-control text-right"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);" v-model.lazy="form.ls_tnh" />
                                    </div>
                                  </td>
                                  <td style="width: 10px">12.</td>
                                  <td>
                                    <div class="form-group">
                                      <money v-bind="money"
                                        :disabled="['14', '15'].includes(form.kode_jns) ? false : true"
                                        class="form-control text-right" style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                        v-model.lazy="form.njop_tan" />
                                    </div>
                                  </td>
                                  <td style="width: 10px">13.</td>
                                  <td>
                                    <div class="form-group">
                                      <money v-bind="money" disabled class="form-control text-right"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);" v-model.lazy="form.jml_tnh" />
                                    </div>
                                  </td>
                                </tr>
                                <tr class="
                                          tr-values
                                          vs-table--tr
                                          tr-table-state-null
                                        ">
                                  <td>Bangunan</td>
                                  <td style="width: 10px">14.</td>
                                  <td>
                                    <div class="form-group">
                                      <money v-bind="money" disabled class="form-control text-right"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);" v-model.lazy="form.ls_bng" />
                                    </div>
                                  </td>
                                  <td style="width: 10px">15.</td>
                                  <td>
                                    <div class="form-group">
                                      <money v-bind="money"
                                        :disabled="['14', '15'].includes(form.kode_jns) ? false : true"
                                        class="form-control text-right" style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                        v-model.lazy="form.njop_bng" />
                                    </div>
                                  </td>
                                  <td style="width: 10px">16.</td>
                                  <td>
                                    <div class="form-group">
                                      <money v-bind="money" disabled class="form-control text-right"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);" v-model.lazy="form.jml_bng" />
                                    </div>
                                  </td>
                                </tr>
                                <tr class="
                                          tr-values
                                          vs-table--tr
                                          tr-table-state-null
                                        ">
                                  <td colspan="4" rowspan="2">
                                    <div style="font-size: 15px;text-align: center;">
                                      <b>Nilai Perolehan Objek Pajak (NPOP)
                                        Berdasarkan</b>
                                    </div>
                                  </td>
                                  <td>
                                    <input type="radio" v-model="form.acuan_self" value="1" />
                                    TOTAL NPOP SELF :
                                  </td>
                                  <td style="width: 10px">17.</td>
                                  <td>
                                    <div class="form-group">
                                      <money v-bind="money" disabled class="form-control text-right"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);" v-model.lazy="form.tot_njop1" />
                                    </div>
                                  </td>
                                </tr>
                                <tr class="
                                          tr-values
                                          vs-table--tr
                                          tr-table-state-null
                                        ">
                                  <td>
                                    <input type="radio" value="2" v-model="form.acuan_self" />
                                    HARGA TRANSAKSI / NILAI PASAR
                                    <span>*</span>
                                  </td>
                                  <td style="width: 10px">18.</td>
                                  <td>
                                    <div class="form-group">
                                      <ValidationProvider name="Harga Transaksi" rules="required" v-slot="{ errors }">
                                        <money v-bind="money" class="form-control text-right"
                                          style="border: 1px solid rgba(0, 0, 0, 0.2);" v-model="form.nilai_transaksi" />
                                        <input type="hidden" v-model.lazy="form.nilai_transaksi">
                                        <div class="text-danger invalid-feedback" v-if="errors[0]">
                                          {{ errors[0] }}</div>
                                      </ValidationProvider>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </fieldset>
                      <br />

                      <div class="row">
                        <div class="col-sm-4 mb-2">
                          <div class="form-group">
                            <label for="" class="base-input--label">NPOP TKP</label>
                            <div class="vs-con-input">
                              <money v-bind="money" type="text" disabled="disabled" class="form-control text-right"
                                style="border: 1px solid rgba(0, 0, 0, 0.2)" v-model="form.npoptkp" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2" v-if="['05'].includes(form.kode_jns)">
                          <base-input type="number" label="APHB 1" class="text-money" v-model.lazy="form.aphb1" />
                        </div>
                        <div class="col-md-2" v-if="['05'].includes(form.kode_jns)">
                          <base-input type="number" label="APHB 2" class="text-money" v-model.lazy="form.aphb2" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-4 mb-2">
                          <div class="form-group">
                            <label for="" class="base-input--label">NILAI KENA PAJAK</label>
                            <div class="vs-con-input">
                              <money v-bind="money" type="text" disabled="disabled" class="form-control text-right"
                                style="border: 1px solid rgba(0, 0, 0, 0.2)" v-model.lazy="form.nkp" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <base-input disabled type="number" label="Pajak (%)" class="text-money" v-model="form.pajak" />
                        </div>
                        <div class="col-sm-4 mb-2">
                          <div class="form-group">
                            <label for="" class="base-input--label">Yang Harus di Bayar</label>
                            <div class="vs-con-input">
                              <money v-bind="money" type="text" disabled="disabled" class="form-control text-right"
                                style="border: 1px solid rgba(0, 0, 0, 0.2)" v-model.lazy="form.pajak_bphtb" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <fieldset style="padding: 5px; margin-top: 10px" v-if="piutang.length == 0">
                      <legend>Dokumen Pendukung</legend>

                      <div class="row">
                        <div class="col-sm-12 mb-2">
                          <span class="text-danger text-sm">Perhatian!</span>
                          <ul>
                            <li><span class="text-danger text-sm">File yang diperbolehkan untuk di upload adalah
                                pdf/jpeg/jpg/png.</span></li>
                            <li><span class="text-danger text-sm">File tidak diperbolehkan lebih dari 2Mb.</span></li>
                          </ul>
                          Jika file yang diupload lebih dari 2mb silahkan untuk compress file tersebut di: <a
                            href="https://www.ilovepdf.com/compress_pdf" target="_blank">Pdf Compress</a> dan <a
                            href="https://imageresizer.com/image-compressor" target="_blank">Image Compress</a>

                        </div>
                      </div>
                      <div class="row">
                        <div class="table-responsive-sm col-md-12">
                          <table class="
                                    table
                                    b-table
                                    table-hover table-bordered table-sm
                                  ">
                            <thead>
                              <tr class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <th>Nama Dokumen</th>
                                <th>Aksi</th>
                              </tr>
                            </thead>
                            <tbody>

                              <tr class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  SPPT PBB dan bukti lunas pembayaran PBB semua pihak<span>*</span>
                                </td>
                                <td id="sspd">
                                  <div v-if="form.sspd">
                                    <button color="success" @click="
                                      downloadFile('sspd')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('sspd')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="SPPT PBB dan bukti lunas harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'sspd'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>



                              <tr v-if="['09', '10'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  SPPT PBB-P3 dan bukti lunas untuk tahun perolehan hak (OP)<span>*</span>
                                </td>
                                <td id="sppt_takhir_pbb_10_thn">
                                  <div v-if="form.sppt_takhir_pbb_10_thn">
                                    <button color="success" @click="
                                      downloadFile('sppt_takhir_pbb_10_thn')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('sppt_takhir_pbb_10_thn')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="SPPT PBB-P3 dan bukti lunas harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'sppt_takhir_pbb_10_thn'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr
                                v-if="['01', '02', '03', '04', '05', '06', '07', '08', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  NPWP bagi yang sudah memilki NPWP
                                </td>
                                <td id="f_mohon_teliti_sspd">
                                  <div v-if="form.f_mohon_teliti_sspd">
                                    <button color="success" @click="
                                      downloadFile('f_mohon_teliti_sspd')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('f_mohon_teliti_sspd')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="NPWP harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'f_mohon_teliti_sspd'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>


                              <tr v-if="['09', '10'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  NPWP Perusahaan
                                </td>
                                <td id="f_mohon_teliti_sspd">
                                  <div v-if="form.f_mohon_teliti_sspd">
                                    <button color="success" @click="
                                      downloadFile('f_mohon_teliti_sspd')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('f_mohon_teliti_sspd')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="NPWP Perusahaan harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'f_mohon_teliti_sspd'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr
                                v-if="['01', '02', '03', '04', '05', '06', '07', '08', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Kepemilikan tanah dan bangunan sertifikat/SKT<span>*</span></td>
                                <td id="fc_kwitansi_draf_ajb">
                                  <div v-if="form.fc_kwitansi_draf_ajb">
                                    <button color="success" @click="downloadFile('fc_kwitansi_draf_ajb')" type="border"
                                      size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('fc_kwitansi_draf_ajb')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Kepemilikan tanah dan bangunan harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_kwitansi_draf_ajb'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['05', '06'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat pengantar dari BPN atau Notaris<span>*</span></td>
                                <td id="pengantar">
                                  <div v-if="form.pengantar">
                                    <button color="success" @click="
                                      downloadFile('pengantar')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('pengantar')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat Pengantar BPN/Notaris harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'pengantar'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>


                              <tr v-if="['07', '08', '09', '10', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat pengantar dari BPN<span>*</span></td>
                                <td id="pengantar">
                                  <div v-if="form.pengantar">
                                    <button color="success" @click="
                                      downloadFile('pengantar')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('pengantar')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat Pengantar BPN harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'pengantar'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['03', '04'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  Akta Kelahiran untuk Hibah dari orang tua kepada anak bawah umur
                                </td>
                                <td id="fc_srt_kuasa_ahli_waris">
                                  <div v-if="form.fc_srt_kuasa_ahli_waris">
                                    <button color="success" @click="
                                      downloadFile('fc_srt_kuasa_ahli_waris')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('fc_srt_kuasa_ahli_waris')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Akta Kelahiran harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_srt_kuasa_ahli_waris'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['01'].includes(form.kode_jns)" class="
                                          tr-values
                                          vs-table--tr
                                          tr-table-state-null
                                        ">
                                <td>Akta Jual Beli (AJB)<span>*</span></td>
                                <td id="fc_sertifikat_ajb">
                                  <div v-if="form.fc_sertifikat_ajb">
                                    <button color="success" @click="downloadFile('fc_sertifikat_ajb')" type="border"
                                      size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('fc_sertifikat_ajb')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Akta Jual Beli (AJB) harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_sertifikat_ajb'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>


                              <tr
                                v-if="['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat Kuasa Wajib Pajak (dalam hal ini yang dikuasakan bermaterai)<span>*</span>
                                </td>
                                <td id="srt_ptanggungjawaban">
                                  <div v-if="form.srt_ptanggungjawaban">
                                    <button color="success" @click="
                                      downloadFile('srt_ptanggungjawaban')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('srt_ptanggungjawaban')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat Kuasa Wajib Pajak harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'srt_ptanggungjawaban'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr
                                v-if="['01', '02', '03', '05', '06', '07', '08', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Foto lokasi tanah/bangunan dilengkapi dengan titik koordinat<span>*</span></td>
                                <td id="foto_objek">
                                  <div v-if="form.foto_objek">
                                    <button color="success" @click="downloadFile('foto_objek')" type="border"
                                      size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="deleteFile('foto_objek')"
                                      type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Foto lokasi tanah/bangunan harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'foto_objek'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>


                              <tr v-if="['09', '10'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Site plane/ Sket tanah<span>*</span></td>
                                <td id="foto_objek">
                                  <div v-if="form.foto_objek">
                                    <button color="success" @click="downloadFile('foto_objek')" type="border"
                                      size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="deleteFile('foto_objek')"
                                      type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Site plane/ Sket tanah harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'foto_objek'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr
                                v-if="['06', '07', '08', '09', '10', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat keterangan tanah dari BPN SK Kepala Kantor Pertanahan<span>*</span></td>
                                <td id="srt_keterangan_tanah">
                                  <div v-if="form.srt_keterangan_tanah">
                                    <button color="success" @click="downloadFile('srt_keterangan_tanah')" type="border"
                                      size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('srt_keterangan_tanah')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="SK Kepala Kantor Pertanahan harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'srt_keterangan_tanah'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>



                              <tr v-if="['06'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat Lelang<span>*</span></td>
                                <td id="lelang">
                                  <div v-if="form.lelang">
                                    <button color="success" @click="downloadFile('lelang')" type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="deleteFile('lelang')"
                                      type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat Lelang harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'lelang'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['05'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat keterangan kematian dari desa/kelurahan</td>
                                <td id="srt_kematian">
                                  <div v-if="form.srt_kematian">
                                    <button color="success" @click="downloadFile('srt_kematian')" type="border"
                                      size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="deleteFile('srt_kematian')"
                                      type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat keterangan kematian harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'srt_kematian'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['05'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  Surat keterangan ahli waris
                                </td>
                                <td id="fc_srt_ket_waris">
                                  <div v-if="form.fc_srt_ket_waris">
                                    <button color="success" @click="downloadFile('fc_srt_ket_waris')" type="border"
                                      size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('fc_srt_ket_waris')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat keterangan ahli waris harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_srt_ket_waris'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['01', '02'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat keterangan notaris/PPAT<span>*</span></td>
                                <td id="dokumen_pendukung_lain">
                                  <div v-if="form.dokumen_pendukung_lain">
                                    <button color="success" @click="
                                      downloadFile('dokumen_pendukung_lain')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('dokumen_pendukung_lain')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat keterangan notaris/PPAT harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'dokumen_pendukung_lain'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr
                                v-if="['01', '02', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat pernyataan wajib pajak bermaterai<span>*</span></td>
                                <td id="fc_identitas_pjual">
                                  <div v-if="form.fc_identitas_pjual">
                                    <button color="success" @click="
                                      downloadFile('fc_identitas_pjual')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('fc_identitas_pjual')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat pernyataan wajib pajak bermaterai harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_identitas_pjual'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['03'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat pernyataan Hibah bermaterai<span>*</span></td>
                                <td id="fc_identitas_pjual">
                                  <div v-if="form.fc_identitas_pjual">
                                    <button color="success" @click="
                                      downloadFile('fc_identitas_pjual')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger"
                                      @click="deleteFile('fc_identitas_pjual')" type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat pernyataan Hibah harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_identitas_pjual'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr
                                v-if="['01', '02', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'].includes(form.kode_jns)"
                                class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>KTP<span>*</span></td>
                                <td id="fc_identitas_wp_pbeli">
                                  <div v-if="form.fc_identitas_wp_pbeli">
                                    <button color="success" @click="
                                      downloadFile('fc_identitas_wp_pbeli')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('fc_identitas_wp_pbeli')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="KTP harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_identitas_wp_pbeli'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>


                              <tr v-if="['03'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>KTP Pemberi dan Penerima<span>*</span></td>
                                <td id="fc_identitas_wp_pbeli">
                                  <div v-if="form.fc_identitas_wp_pbeli">
                                    <button color="success" @click="
                                      downloadFile('fc_identitas_wp_pbeli')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('fc_identitas_wp_pbeli')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="KTP Pemberi dan Penerima harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_identitas_wp_pbeli'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['03'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  Kartu Keluarga Pemberi dan Penerima
                                </td>
                                <td id="fc_kk_srt_ket_hub_klg">
                                  <div v-if="form.fc_kk_srt_ket_hub_klg">
                                    <button color="success" @click="
                                      downloadFile('fc_kk_srt_ket_hub_klg')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('fc_kk_srt_ket_hub_klg')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Kartu Keluarga harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_kk_srt_ket_hub_klg'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>


                              <tr v-if="['04', '05'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>
                                  Kartu Keluarga
                                </td>
                                <td id="fc_kk_srt_ket_hub_klg">
                                  <div v-if="form.fc_kk_srt_ket_hub_klg">
                                    <button color="success" @click="
                                      downloadFile('fc_kk_srt_ket_hub_klg')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('fc_kk_srt_ket_hub_klg')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Kartu keluarga harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_kk_srt_ket_hub_klg'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>

                              <tr v-if="['02'].includes(form.kode_jns)" class="
                                        tr-values
                                        vs-table--tr
                                        tr-table-state-null
                                      ">
                                <td>Surat keterangan perjanjian Tukar Menukar yang diketahui oleh
                                  Notaris/PPAT<span>*</span></td>
                                <td id="tukar_menukar">
                                  <div v-if="form.tukar_menukar">
                                    <button color="success" @click="
                                      downloadFile('tukar_menukar')
                                      " type="border" size="small">
                                      Download File
                                    </button>
                                    <button style="margin-left: 5px" color="danger" @click="
                                      deleteFile('tukar_menukar')
                                      " type="border" size="small">
                                      Hapus File
                                    </button>
                                  </div>
                                  <template v-else>
                                    <ValidationProvider name="Surat keterangan perjanjian Tukar Menukar harus di upload" rules="required"
                                      v-slot="{ validate, errors }">
                                      <div class="form-group">
                                        <input type="file" class="form-control" @change="
                                          uploadFiles(
                                            $event,
                                            'fc_kk_srt_ket_hub_klg'
                                          ) || validate($event)
                                          " />
                                        <span class="text-danger text-sm" v-show="errors[0]">{{
                                          errors[0]
                                        }}</span>
                                      </div>
                                    </ValidationProvider>
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </fieldset>
                    <br />
                    <!-- / PAGE CONTENT ENDS -->
                    <div class="row float-right" v-if="piutang.length == 0">
                      <div class="col-md-12 col-sm-12">
                        <template v-if="isBusy">
                          <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                          <strong>Loading...</strong>
                        </template>
                        <template v-else>
                          <base-button tag="a" class="mb-3 mb-sm-0" type="info" textColor="black" icon="fa fa-arrow-left"
                            @click="goback()">Kembali</base-button>
                          <base-button type="success" nativeType="submit" icon="ni ni-send">{{
                            edit ? "Update" :
                            "Simpan"
                          }}</base-button>
                          <base-button v-if="edit" @click="cetakPendaftaran" type="primary" icon="ni ni-print">Cetak Bukti
                            Pendaftaran BPHTB
                          </base-button>
                        </template>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </card>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import { formatMoney } from "accounting-js";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { Money } from "v-money";
import MaskedInput from "vue-masked-input";

export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Money,
    MaskedInput
  },
  props: ['id'],
  watch: {
    "form.ls_tnh": function () {
      this.calculateField();
    },
    "form.njop_tan": function () {
      this.calculateField();
    },
    "form.ls_bng": function () {
      this.calculateField();
    },
    "form.njop_bng": function () {
      this.calculateField();
    },
    "form.nilai_transaksi": function () {
      this.calculateField();
    },
    "form.kode_jns": function () {
      this.calculateField();
    },
    "form.pengurangan": function () {
      this.calculateField();
    },
    "form.aphb1": function () {
      this.calculateField();
    },
    "form.aphb2": function () {
      this.calculateField();
    },
    "form.kode_jns": function () {
      this.cekNop();
    },
    "form.objek_pajak.nop": function () {
      this.cekNop();
    },
    "form.wajib_pajak.nik": function () {
      this.getNik();
    },
    originalData: {
      handler: function () {
        this.form.objek_pajak.nop = this.originalData.daftar.kd_propinsi + this.originalData.daftar.kd_dati2 + this.originalData.daftar.kd_kecamatan + this.originalData.daftar.kd_kelurahan + this.originalData.daftar.kd_blok + this.originalData.daftar.no_urut + this.originalData.daftar.kd_jns_op
        this.form.jenis_wp = this.originalData.daftar.jenis_wp
        this.form.wajib_pajak.nik = this.originalData.daftar.nik_wp
        this.form.thn_pajak = this.originalData.setoran.thn_pajak
        this.form.jenis_sk = this.originalData.setoran.jenis_sk
        this.form.kode_jns = this.originalData.setoran.kode_jns

        this.form.ls_bng = this.originalData.setoran.ls_bng;
        this.form.ls_tnh = this.originalData.setoran.ls_tnh;
        this.form.njop_bng = this.originalData.setoran.njop_bng;
        this.form.njop_tan = this.originalData.setoran.njop_tan;

        this.form.nilai_transaksi = this.originalData.setoran.nilai_transaksi;

        this.form.fc_sertifikat_ajb = this.originalData.daftar.fc_sertifikat_ajb_path;
        this.form.fc_identitas_pjual = this.originalData.daftar.fc_identitas_pjual_path;
        this.form.fc_identitas_wp_pbeli = this.originalData.daftar.fc_identitas_wp_pbeli_path;
        this.form.sppt_takhir_pbb_10_thn = this.originalData.daftar.sppt_takhir_pbb_10_thn_path;
        this.form.sspd = this.originalData.daftar.sspd_path;
        this.form.srt_ptanggungjawaban = this.originalData.daftar.srt_ptanggungjawaban_path;
        this.form.f_mohon_teliti_sspd = this.originalData.daftar.f_mohon_teliti_sspd_path;
        this.form.fc_srt_ket_waris = this.originalData.daftar.fc_srt_ket_waris_path;
        this.form.fc_srt_kuasa_ahli_waris = this.originalData.daftar.fc_srt_kuasa_ahli_waris_path;
        this.form.srt_kematian = this.originalData.daftar.srt_kematian_path;
        this.form.fc_kk_srt_ket_hub_klg = this.originalData.daftar.fc_kk_srt_ket_hub_klg_path;
        this.form.dokumen_pendukung_lain = this.originalData.daftar.dokumen_pendukung_lain_path;
        this.form.sspd1 = this.originalData.daftar.sspd1_path;
        this.form.fc_kwitansi_draf_ajb = this.originalData.daftar.fc_kwitansi_draf_ajb_path;


        this.form.foto_objek = this.originalData.daftar.foto_objek_path;
        this.form.srt_keterangan_tanah = this.originalData.daftar.srt_keterangan_tanah_path;
        this.form.tukar_menukar = this.originalData.daftar.tukar_menukar_path;
        this.form.lelang = this.originalData.daftar.lelang_path;
        this.form.pengantar = this.originalData.daftar.pengantar_path;

        this.item = this.originalData.daftar;
      },
      deep: true
    },
  },
  data() {
    return {
      loadingCetakTunggakan: false,
      edit: false,
      modals: {
        modal1: false,
      },
      isBusyNop: false,
      isBusyWp: false,
      isBusy: false,
      npoptkp: true,
      item: null,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 0,
        masked: true /* doesn't work with directive */,
      },
      piutang: [],
      optionJenisSK: [
        { text: "SSPD", value: "01" },
        { text: "SSPD", value: "05" },
      ],
      optionPpat: [],
      optionPeralihan: [],
      originalData: [],
      form: {
        persyaratan: 1,
        jenis_wp: 1,
        jenis_sk: "01",
        thn_pajak: new Date().getFullYear(),
        kode_ppat: null,
        ls_tnh: 0,
        njop_tan: 0,
        jml_tnh: 0,
        ls_bng: 0,
        njop_bng: 0,
        jml_bng: 0,
        tot_njop1: 0,
        nilai_transaksi: 0,
        kode_jns: null,
        npoptkp: 0,
        aphb1: null,
        aphb2: null,
        nkp: 0,
        pajak: 5,
        pajak_bphtb: 0,
        pengurangan: null,
        acuan_self: null,
        fc_sertifikat_ajb: null,
        fc_identitas_pjual: null,
        fc_identitas_wp_pbeli: null,
        sppt_takhir_pbb_10_thn: null,
        sspd: null,
        srt_ptanggungjawaban: null,
        f_mohon_teliti_sspd: null,
        fc_srt_ket_waris: null,
        fc_srt_kuasa_ahli_waris: null,
        srt_kematian: null,
        fc_kk_srt_ket_hub_klg: null,
        dokumen_pendukung_lain: null,
        sspd1: null,
        fc_kwitansi_draf_ajb: null,
        foto_objek: null,
        srt_keterangan_tanah: null,
        tukar_menukar: null,
        lelang: null,
        pengantar: null,
        objek_pajak: {
          nop: null,
          kd_propinsi: null,
          kd_dati2: null,
          kd_kecamatan: null,
          kd_kelurahan: null,
          kd_blok: null,
          no_urut: null,
          kd_jns_op: null,
          nama: null,
          jalan_op: null,
          no_sertf: null,
          nik_pemilik: null,
          no_telp: null,
        },
        subjek_pajak: {
          nm_wp: null,
        },
        wajib_pajak: {
          nik: null,
          nama: null,
          npwp: null,
          jalan: null,
          blok_kav_no: null,
          rt: null,
          rw: null,
          kelurahan: null,
          kecamatan: null,
          kota: null,
          kd_pos: null,
          handphone: null
        },
      },
    };
  },
  computed: {
    labelIdenditas() {
      return this.form.jenis_wp == 1 ? "NIK (KTP)" : this.form.jenis_wp == 2 ? "NPWP" : "NOP"
    }
  },
  mounted() {
    this.showModal();
  },
  methods: {
    async submit() {
      const vm = this;
      this.$refs.formObserver.validate().then(async (result) => {
        if (result) {
          // if(this.form.nilai_transaksi == null || this.form.nilai_transaksi == 0 || this.form.nilai_transaksi == '' || this.form.nilai_transaksi == '0' ){
          //   alert('Nilai Transaksi Kosong');
          //   return false;
          // } else {
          try {
            vm.calculateField();
            vm.isBusy = true;
            if (vm.$route.params.id) vm.form.no_reg = vm.$route.params.id;
            let { data, status } = vm.$route.params.id
              ? await axios.post("/api/v1/bphtb/create", vm.form)
              : await axios.post("/api/v1/bphtb/create", vm.form);
            if (status >= 200 && status <= 202) {
              Swal.fire({
                title: "",
                html: vm.$route.params.id
                  ? "Update data berhasil."
                  : "Pendaftaran Pajak BPHTB Berhasil, Terima kasih sudah mendata pajak Anda. <br>Silahkan tunggu verifikasi dari petugas kami.",
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Tutup!"
              }).then((result) => {
                vm.edit = true
                vm.item = data
                vm.form.no_reg = data.no_reg
                if (result.isConfirmed) {

                }
              });
            }
          } catch (error) {
            // console.log(error)
          } finally {
            vm.isBusy = false;
          }
          // }
        } else {
          alert('Periksa Input Anda');
        }
      });
    },
    async uploadFiles(event, name) {
      const files = event.target.files;
      const file = new FormData();
      file.append("file", files[0]);
      file.append("nop", this.form.objek_pajak.nop);
      let fileName = files[0]["name"];
      file.append(
        "filename",
        name + "." + fileName.substr(fileName.lastIndexOf(".") + 1)
      );
      if (files[0]["size"] > 1024 * 1024 * 2) {
        alert("File terlalu besar harus kurang dari 2MB (> 2MB)");
        return;
      }
      if (
        files[0]["type"] != "image/png" &&
        files[0]["type"] != "image/jpeg" &&
        files[0]["type"] != "application/pdf"
      ) {
        alert("File yang Anda upload bukan PDF/Image");
        return;
      }
      try {
        let { data } = await axios.post("/api/v1/upload", file);
        this.form[name] = data;
      } catch (error) {
        // console.log(error);
        this.form[name] = null;
      } finally {
      }
    },
    downloadFile(name) {
      axios({
        url: "/api/v1/download_pdf?nop=" + this.form.objek_pajak.nop + "&filename=" + this.form[name], //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", this.form[name]); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    deleteFile(name) {
      this.form[name] = null;
    },
    isString(myVar) {
      return (typeof myVar === 'string' || myVar instanceof String)
    },
    calculateField() {
      let ls_tnh = this.isString(this.form.ls_tnh) ? this.form.ls_tnh.split('.').join('') : this.form.ls_tnh;
      let njop_tan = this.isString(this.form.njop_tan) ? this.form.njop_tan.split('.').join('') : this.form.njop_tan;
      let ls_bng = this.isString(this.form.ls_bng) ? this.form.ls_bng.split('.').join('') : this.form.ls_bng;
      let njop_bng = this.isString(this.form.njop_bng) ? this.form.njop_bng.split('.').join('') : this.form.njop_bng;
      let nilai_transaksi = this.isString(this.form.nilai_transaksi) ? this.form.nilai_transaksi.split('.').join('') : this.form.nilai_transaksi;

      let jml_tnh = ls_tnh * njop_tan;
      let jml_bng = ls_bng * njop_bng;
      let tot_njop1 = jml_tnh + jml_bng;

      this.form.jml_tnh = jml_tnh;
      this.form.jml_bng = jml_bng;
      this.form.tot_njop1 = tot_njop1;

      if (nilai_transaksi > tot_njop1)
        this.form.acuan_self = 2;
      else this.form.acuan_self = 1;
      this.optionPeralihan.forEach((element) => {
        if (this.form.kode_jns == element.kode_jns) {
          this.form.npoptkp = element.npoptkp;
          return;
        }
      });

      if (this.form.kode_jns == '08')
        this.form.acuan_self = 2;

      if (!this.npoptkp) this.form.npoptkp = 0;

      let npoptkp = this.isString(this.form.npoptkp) ? this.form.npoptkp.split('.').join('') : this.form.npoptkp;

      let nkp =
        this.form.acuan_self == 1
          ? tot_njop1 - npoptkp
          : nilai_transaksi - npoptkp;

      if (parseInt(this.form.jenis_wp) == 3) nkp = 0
      this.form.nkp = nkp

      if (nkp <= 0) {
        nkp = 0;
        this.form.pajak_bphtb = 0;
        this.form.nkp = 0
        this.form.jenis_sk = "05";
      } else {
        this.form.jenis_sk = "01";
        let nilaiaphb = parseInt(this.form.aphb1) / parseInt(this.form.aphb2);
        if (this.form.aphb1 == "" || this.form.aphb1 == null) nilaiaphb = 1;
        if (this.form.aphb2 == "" || this.form.aphb2 == null) nilaiaphb = 1;
        let pengurangan = 0;
        let pajak_bphtb = ((nilaiaphb * (nkp * 5)) / 100) - pengurangan;
        this.form.pajak_bphtb = Math.ceil(pajak_bphtb)

        if (pajak_bphtb <= 0) {
          this.form.jenis_sk = "05";
          this.form.pajak_bphtb = 0;
        } else this.form.jenis_sk = "01";
      }
    },
    formatMoney(val) {
      return formatMoney(val, {
        symbol: "Rp. ",
        precision: 0,
        thousand: ".",
        decimal: ",",
      });
    },
    showModal() {
      const me = this;
      this.form.kode_ppat = this.$store.state.auth.user.kode_ppat;
      this.isBusy = true;
      axios.get("/api/v1/bphtb/jenis-peralihan").then(function (response) {
        me.optionPeralihan = response.data;
        if (me.$route.params.id) {
          me.isBusy = true;
          axios.get("/api/v1/bphtb/show?id=" + me.$route.params.id).then(function (response) {
            me.originalData = response.data;
            me.edit = true
          }).finally(() => {
            me.isBusy = false;
          });
        }
      }).finally(() => {
        me.isBusy = false;
      });
    },
    getNik() {
      if (this.form.jenis_wp == 2) {
        if (
          this.form.wajib_pajak.nik == null ||
          this.form.wajib_pajak.nik == "" ||
          this.form.wajib_pajak.nik.length < 15
        )
          return;
      } else {
        if (
          this.form.wajib_pajak.nik == null ||
          this.form.wajib_pajak.nik == "" ||
          this.form.wajib_pajak.nik.length < 16
        )
          return;
      }
      this.isBusyWp = true;

      const me = this;
      me.form.wajib_pajak.nama = null;
      me.form.wajib_pajak.npwp = null;
      me.form.wajib_pajak.jalan = null;
      me.form.wajib_pajak.blok_kav_no = null;
      me.form.wajib_pajak.rt = null;
      me.form.wajib_pajak.rw = null;
      me.form.wajib_pajak.kelurahan = null;
      me.form.wajib_pajak.kecamatan = null;
      me.form.wajib_pajak.kota = null;
      me.form.wajib_pajak.kd_pos = null;
      me.form.wajib_pajak.handphone = null;
      me.npoptkp = true;
      axios
        .get("/api/v1/bphtb/cek-wajib-pajak?nik=" + this.form.wajib_pajak.nik + "&no_reg=" + this.$route.params.id)
        .then(function (response) {
          if (response.data.wajib_pajak.subjek_pajak_id) {
            me.form.wajib_pajak.nama = response.data.wajib_pajak.nm_wp;
            me.form.wajib_pajak.npwp = response.data.wajib_pajak.npwp;
            me.form.wajib_pajak.jalan = response.data.wajib_pajak.jalan_wp;
            me.form.wajib_pajak.blok_kav_no =
              response.data.wajib_pajak.blok_kav_no_wp;
            me.form.wajib_pajak.rt = response.data.wajib_pajak.rt_wp;
            me.form.wajib_pajak.rw = response.data.wajib_pajak.rw_wp;
            me.form.wajib_pajak.kelurahan =
              response.data.wajib_pajak.kelurahan_wp;
            me.form.wajib_pajak.kecamatan = null;
            me.form.wajib_pajak.kota = response.data.wajib_pajak.kota_wp;
            me.form.wajib_pajak.kd_pos = response.data.wajib_pajak.kd_pos_wp;
          } else {
            me.form.wajib_pajak.nama = response.data.wajib_pajak.nama;
            me.form.wajib_pajak.npwp = response.data.wajib_pajak.npwp;
            me.form.wajib_pajak.jalan = response.data.wajib_pajak.jalan;
            me.form.wajib_pajak.blok_kav_no =
              response.data.wajib_pajak.blok_kav_no;
            me.form.wajib_pajak.rt = response.data.wajib_pajak.rt;
            me.form.wajib_pajak.rw = response.data.wajib_pajak.rw;
            me.form.wajib_pajak.kelurahan = response.data.wajib_pajak.kelurahan;
            me.form.wajib_pajak.kecamatan = response.data.wajib_pajak.kecamatan;
            me.form.wajib_pajak.kota = response.data.wajib_pajak.kota;
            me.form.wajib_pajak.kd_pos = response.data.wajib_pajak.kd_pos;
            me.form.wajib_pajak.handphone = response.data.wajib_pajak.handphone;
          }
          me.npoptkp = response.data.npoptkp;

          me.calculateField();
        })
        .catch((error) => { })
        .finally(() => {
          this.isBusyWp = false;
        });
    },
    cekNop() {
      let nop = this.form.objek_pajak.nop.split('.').join('').replace(/_/g, '');
      if (
        nop == null ||
        nop == "" ||
        nop.length != 18
      )
        return;

      this.piutang = [];
      this.form.subjek_pajak.jalan_op = null;
      this.form.subjek_pajak.nm_wp = null;
      this.form.objek_pajak.no_sertf = null;
      this.form.objek_pajak.no_telp = null;
      this.isBusyNop = true;
      this.isBusy = true;

      const me = this;
      axios
        .get("/api/v1/bphtb/cek-piutang?nop=" + nop + "&no_reg=" + this.$route.params.id)
        .then(function (response) {
          if (response.data.objek_pajak == null) {
            Swal.fire({
              title: "NOP Tidak di Temukan",
              text: "NOP Anda masukan tidak ditemukan!",
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Tutup!",
            });
          } else {


            me.form.subjek_pajak.jalan_op = response.data.subjek_pajak.jalan_wp;
            me.form.subjek_pajak.nm_wp = response.data.subjek_pajak.nm_wp;
            me.form.objek_pajak.no_sertf = response.data.pbb_data.no_sertf;
            me.form.objek_pajak.nik_pemilik = response.data.subjek_pajak.subjek_pajak_id;
            me.form.objek_pajak.no_telp = response.data.pbb_data.no_telp;
            // if (me.form.kode_jns != '15') {
            if (response.data.piutang.length > 0) {
              Swal.fire({
                title: "NOP Terhutang",
                text: "NOP Anda masukan memiliki piutang PBB!",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Tutup!",
              });
              me.piutang = response.data.piutang;
            } else {

              // }

              // if (response.data.pbb_data.length > 0) {

              // if (me.$route.params.id == null) {
              let total_luas_bumi = response.data.pbb_data.total_luas_bumi == 0 || response.data.pbb_data.total_luas_bumi == null ? 1 : response.data.pbb_data.total_luas_bumi
              let total_luas_bng = response.data.pbb_data.total_luas_bng == 0 || response.data.pbb_data.total_luas_bng == null ? 1 : response.data.pbb_data.total_luas_bng
              let njopBumi = response.data.pbb_data.njop_bumi / total_luas_bumi
              let njopBng = response.data.pbb_data.njop_bng / total_luas_bng
              me.form.ls_bng = response.data.pbb_data.total_luas_bng;
              me.form.ls_tnh = response.data.pbb_data.total_luas_bumi;
              me.form.njop_bng = njopBng;
              me.form.njop_tan = njopBumi;

              me.calculateField();
              // }
            }
          }
        })
        .catch((error) => { })
        .finally(() => {
          this.isBusyNop = false;
          this.isBusy = false;
        });
    },
    cetakTunggakan() {
      this.loadingCetakTunggakan = true
      axios({
        url: "/api/v1/bphtb/download-tunggakan?nop=" + this.form.objek_pajak.nop,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", this.form.objek_pajak.nop + '.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => {
        this.loadingCetakTunggakan = false
      });
    },
    goback() {
      this.$router.go(-1);
    },
    cetakPendaftaran() {
      axios({
        url: "/api/v1/bphtb/cetak-pendaftaran?id=" + this.item.no_reg, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", 'PENDAFTARAN_' + this.item.no_reg + '.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}

.has-success:after,
.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 29px;
  -webkit-transform: translateY(50%);
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

.section-shaped .shape.shape-skew+.shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card {
  height: 100%;
  width: 100%;
}

.vs-table--tr>th {
  font-size: 1rem !important;
}


.vs-table--tr>td {
  font-size: 1rem !important;
}
</style>